import { render, staticRenderFns } from "./SalepointDetailDialog.vue?vue&type=template&id=bac66de6&scoped=true&"
import script from "./SalepointDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SalepointDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac66de6",
  null
  
)

export default component.exports